module.exports = __webpack_public_path__ + "static/media/personPayslip.ea2ca840.svg";